// extracted by mini-css-extract-plugin
export var intro = "index-module--intro--2KSmr";
export var illustration = "index-module--illustration--3ihLR";
export var logoWrapper = "index-module--logoWrapper--aVY79";